import React, { useState, useEffect } from 'react';
import "./header.css"
import logo from "../../assets/tagline-and-imagetype-white.svg"
import logo_black from "../../assets/tagline-and-imagetype-white.svg"

const Header = () => {

    const [logoSrc, setLogoSrc] = useState(window.innerWidth < 992 ? logo_black : logo)

    const[Toggle, showMenu] = useState();

    const [activeNav, setActiveNav] = useState("#home");


   /* window.addEventListener("scroll", function () {
        const header = document.querySelector(".header");
        if (this.scrollY >= 80) {
            header.classList.add("scroll-header");
        } 
        else {
            header.classList.remove("scroll-header")
        } 
    })*/


    const handleLogoSrcSet = () => {
        if(window.innerWidth < 992) {
            setLogoSrc(logo_black)
        } else {
            setLogoSrc(logo)
        }
    }

    useEffect(() => {
        window.addEventListener('resize', handleLogoSrcSet)

        return () => {
            window.removeEventListener('resize', handleLogoSrcSet)
        }
    }, [])






  return (
    <header className='header' id="header">
        <div className='header__container'>
        <nav className='nav'>
            <a href='index.html' className='nav__logo'>
                <img src={logoSrc} alt="" className='nav__logoimg' />
            </a>
            <div className="nav__line"></div> {/* Línea agregada */}
             <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
                <ul className='nav__list grid'>
                    <li className='nav__item'>
                        <a href="#home" onClick={() => setActiveNav("#home")} 
                        className={activeNav === "#home" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-estate nav__icon"></i>
                            Home
                        </a>
                    </li>
                    
                    <li className='nav__item'>
                        <a href="#business" onClick={() => setActiveNav("#about")} 
                        className={activeNav === "#about" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-user nav__icon"></i>
                            About
                        </a>
                    </li>

                    <li className='nav__item'>
                        <a href="#services" onClick={() => setActiveNav("#services")} 
                        className={activeNav === "#services" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-briefcase-alt nav__icon"></i>
                            Services
                        </a>
                    </li>

                    <li className='nav__item'>
                        <a href="#testimonials" onClick={() => setActiveNav("#testimonials")} 
                        className={activeNav === "#skills" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-file-alt nav__icon"></i>
                            Testimonials
                        </a>
                    </li>

                    <li className='nav__item'>
                        <a href="#contact" onClick={() => setActiveNav("#contact")} 
                        className={activeNav === "#contact" ? "nav__link active-link" : "nav__link"}>
                            <i className="uil uil-message nav__icon"></i>
                            Contact
                        </a>
                    </li>
                </ul>

                <i className="uil uil-times nav__close" onClick={() => showMenu
              (!Toggle)}></i>
             </div>

             <div className='nav__toggle' onClick={() => showMenu
              (!Toggle)}>
             <i className="uil uil-apps"></i>
             </div>
            
        </nav>
        </div>
    </header>
  )
}

export default Header
